import { render, staticRenderFns } from "./StickerDecoration.vue?vue&type=template&id=2d446a40&name=sticker-decoration&"
import script from "./StickerDecoration.vue?vue&type=script&lang=js&"
export * from "./StickerDecoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports